import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { seoConfig } from "@/data/seoConfig";

const NotFound = () => (
  <>
    <SEO {...seoConfig.notFound} />
    <main className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-32">
      <span className="text-sm font-semibold tracking-[0.25em] uppercase text-miti-blue">404</span>
      <h1 className="mt-4 font-heading font-bold tracking-tight text-4xl sm:text-5xl text-slate-900">
        Page Not Found
      </h1>
      <p className="mt-4 max-w-md text-base text-slate-500 leading-relaxed">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center rounded-md bg-miti-navy px-7 py-3.5 text-sm font-semibold text-white hover:bg-miti-blue transition-colors"
      >
        Back to Home
      </Link>
    </main>
  </>
);

export default NotFound;
